import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, Platform } from '@ionic/angular';
import { ONEBILL_APP_ID, ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { ApiService } from '@1bill-app/services/api/api.service';
import { UIService } from '@1bill-app/services/ui.service';
import { Market } from '@ionic-native/market/ngx';
import { version } from '../../../../package.json';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-force-app-update',
  templateUrl: './force-app-update.page.html',
  styleUrls: ['./force-app-update.page.scss'],
})
export class ForceAppUpdatePage implements OnInit {
  constructor(
    private api: ApiService,
    private uiService: UIService,
    private market: Market,
    private platform: Platform,
    private router: Router,
    private routerOutlet: IonRouterOutlet
  ) {}

  public nativePlatform: 'ios' | 'android' = this.platform.is('ios') ? 'ios' : 'android';
  public nativeMarket = this.nativePlatform == 'ios' ? 'App Store' : 'Play Store';

  loading = false;

  version = version;
  userPlatform = Capacitor.getPlatform();

  ngOnInit() {

    this.routerOutlet.swipeGesture = false; // prevents swiping back to login page
    this.uiService.newAppVersionAvailable().subscribe((res) => {
      if (res.newVersionAvailable && res.forceUpdateApp) {
      } else {
        this.router.navigate([ROUTE_HOMEPAGE]);
      }
    });
  }

  async openAppInMarket() {
    const marketAppId =
      this.nativePlatform === 'ios' ? ONEBILL_APP_ID.ios : ONEBILL_APP_ID.android;
    await this.market.open(marketAppId);
  }

  //check if a new version is availalbe
  //if returned true, update app
  async checkAppVersion() {
    this.loading = true;
    await this.openAppInMarket()
      .then((res) => {
        this.loading = false;
      })
      .catch((err) => {
        console.error({ err });
        this.loading = false;
      });

  }
}
